import React from 'react';
import { motion } from 'framer-motion';
const faqs = [{
  q: '¿Necesito equipo profesional?',
  a: 'No. El 90% del contenido viral se graba con celulares. Usás el que ya tenés.'
}, {
  q: '¿Cuánto tiempo lleva?',
  a: 'Podés verlo en un fin de semana y empezar a aplicar el lunes.'
}, {
  q: '¿Sirve si estoy empezando?',
  a: 'Sí. Si tu nivel es aceptable, esto te acelera años de proceso.'
}];
export function ObjectionsSection() {
  return <section className="px-6 py-32 md:py-40 bg-white text-black" data-id="element-58">
      <div className="w-full max-w-3xl mx-auto" data-id="element-59">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-4xl md:text-6xl font-black tracking-tight mb-16 text-center" data-id="element-60">
          Preguntas Frecuentes
        </motion.h2>

        <div className="space-y-6" data-id="element-61">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-zinc-50 p-8 md:p-10 rounded-3xl" data-id="element-62">
              <h3 className="text-2xl md:text-3xl font-bold mb-3" data-id="element-63">{faq.q}</h3>
              <p className="text-xl text-gray-600 font-light leading-relaxed" data-id="element-64">
                {faq.a}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}